module.exports = __webpack_public_path__ + "static/media/8OLA26.cdd7f2d3.jpg";